export class StopPredictionData {
  routeId: string;
  destination: string;
  vehicleId: string;
  info1: string;
  info2: string;
  lat: number;
  lon: number;
  tripId: string;

  deserialize(input: any) {
    (<any>Object).assign(this, input);
    (<any>Object).assign(this, input.route);
    return this;
  }

}
